module.exports = __webpack_public_path__ + "static/media/mail_icon.4d1fb585.svg";